'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';

// 🔥 ОБНОВЛЕНО: Добавлена "Нумерология"
const menuItems = [
  { href: '/horoscope/daily/common', label: 'Ежедневный' },
  { href: '/horoscope/compatibility', label: 'Совместимость' },
  { href: '/horoscope/chinese', label: 'Китайский' },
  { href: '/horoscope/tarot', label: 'Карта дня' },
  { href: '/horoscope/numerology', label: 'Нумерология' }, // 🔥 НОВЫЙ ПУНКТ
  { href: '/horoscope/moon', label: 'Лунный календарь' },   // ✅ NEW
  { href: '/horoscope/events', label: 'Астрособытия' }, 
];

// 🔥 Performance: Оборачиваем в memo
const HoroscopeMenu = React.memo(function HoroscopeMenu() {
  const pathname = usePathname();

  return (
    // 🔥 A11y: Добавлен aria-label
    // 🔥 Adaptivity: Добавлен flex-wrap для переноса на мобильных
    <nav
      aria-label="Навигация по разделу гороскопов"
      className="mb-8 flex justify-center items-center flex-wrap gap-x-6 gap-y-2 sm:gap-x-8 border-b border-gray-700 pb-4"
    >
      {menuItems.map((item) => {
        const isActive =
        pathname === item.href ||
        pathname.startsWith(item.href + '/') ||
        (item.href === '/horoscope/daily/common' && pathname.startsWith('/horoscope/daily'));
        return (
          <Link
            key={item.href}
            href={item.href}
            className={`
              text-lg sm:text-xl font-semibold transition-colors duration-200 px-2 py-1 rounded-md
              ${
                isActive
                  ? 'text-yellow-400' // Цвет активной вкладки
                  : 'text-gray-400 hover:text-white'
              }
              focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400
            `}
            aria-current={isActive ? 'page' : undefined}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
});

HoroscopeMenu.displayName = 'HoroscopeMenu'; // Для удобной отладки
export default HoroscopeMenu;
